"use client"
import React, { useCallback, useMemo } from "react"
import { useTranslations } from "next-intl"
import { useQueryState } from "nuqs"
import { planItemParser } from "../queryStates"
import { Card, Stack, Text, List, Button, Title, ThemeIcon, Center, Checkbox } from "@mantine/core"
import { IconUsers, IconCircleCheck } from "@tabler/icons-react"
import classes from "./styles/PlanItem.module.css"

export function TeamCard() {
  const [selectedPlan, selectPlan] = useQueryState("plan", planItemParser)
  const [isQualified, setIsQualified] = React.useState(false)
  const t = useTranslations()

  const isSelected = useMemo(() => {
    return selectedPlan === "team"
  }, [selectedPlan])

  const handleClick = useCallback(() => {
    selectPlan("team")
  }, [selectPlan])

  const formatTextWithBold = (text: string) => {
    const parts = text.split(/(\*\*[^*]+\*\*)/)
    return parts.map((part, index) => {
      if (part.startsWith("**") && part.endsWith("**")) {
        const boldText = part.slice(2, -2)
        return (
          <Text key={index} component="span" fw={700} c="dark">
            {boldText}
          </Text>
        )
      }
      return part
    })
  }

  const formatText = (text: string) => {
    return text.split("\n\n").map((paragraph, index) => (
      <Text key={index} size="sm" c="dimmed" mb="sm">
        {formatTextWithBold(paragraph)}
      </Text>
    ))
  }

  return (
    <Card className={classes.root} radius="md" withBorder onClick={handleClick} data-selected={isSelected} data-plan-id="team" padding="lg">
      <Stack h="100%" justify="space-between">
        <Stack gap="md">
          <Center mb="md">
            <ThemeIcon variant="light" size={64} color="yellow" className={classes.icon}>
              <IconUsers size={32} />
            </ThemeIcon>
          </Center>

          <Title order={1} size="h2" fw={700} c="dark" className={classes.title} ta="center" mb="md">
            {t("signUp.plans.team.displayName")}
          </Title>

          <Stack gap="sm" ta="center">
            <Stack gap="xs" mx="xl">
              {formatText(t("signUp.plans.team.description"))}
            </Stack>

            <Text size="sm" fw={500} c="dark" ta="center" my="md">
              {t("signUp.plans.team.qualification")}
            </Text>
            <List size="sm" spacing="md" c="dimmed" className={classes.qualificationList} icon={<IconCircleCheck size={16} />} mx="xl">
              {["signUp.plans.team.qualificationList.0", "signUp.plans.team.qualificationList.1", "signUp.plans.team.qualificationList.2", "signUp.plans.team.qualificationList.3"].map((item, index) => (
                <List.Item key={index} className={classes.listItem}>
                  {t(item)}
                </List.Item>
              ))}
            </List>

            <Center mb="sm">
              <Checkbox checked={isQualified} onChange={(event) => setIsQualified(event.currentTarget.checked)} label="I believe I qualify for this type of account" size="sm" mt="md" />
            </Center>
          </Stack>
        </Stack>

        <Button component="a" href="/sign-up/team" fullWidth size="md" className={classes.button} variant="filled">
          {t("signUp.plans.team.continueButton")}
        </Button>
      </Stack>
    </Card>
  )
}
